/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "952a687a1491b6200de1ad23a82e7174335710b8";
